<template>
  <div>
    <header-card
      :title="$t('reply.form.edit-template')"
      show-back
      :route-url="{name:'owner:reply-templates'}"
    />
    <process-reply
      :edit="true"
      is-template
    />
  </div>
</template>

<script>
import ProcessReply from '@/views/owner-instagram/reply/components/ProcessReply'
import HeaderCard from '@/@bya3/components/cards/HeaderCard'

export default {
  name: 'EditReplyTemplate',
  components: { HeaderCard, ProcessReply },
}
</script>
